module.exports = __webpack_public_path__ + "img/b.dff8aa64.jpg";